/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EditUserRequest } from '../models/EditUserRequest';
import type { KycFormResponse } from '../models/KycFormResponse';
import type { MyEstateDto } from '../models/MyEstateDto';
import type { User } from '../models/User';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserService {

    /**
     * @param sessionId
     * @returns User Success
     * @throws ApiError
     */
    public static userGetUser(
        sessionId?: string,
    ): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/User/User',
            query: {
                'sessionId': sessionId,
            },
        });
    }

    /**
     * @param sessionId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static userUpdateProfile(
        sessionId?: string,
        requestBody?: EditUserRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/User/UpdateProfile',
            query: {
                'sessionId': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param officeId
     * @returns any Success
     * @throws ApiError
     */
    public static userUpdateProfileOffice(
        sessionId?: string,
        officeId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/User/User/UpdateProfileOffice',
            query: {
                'sessionId': sessionId,
                'officeId': officeId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static userGetDeclarationBasis(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/User/Form/DeclarationBasises',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @returns any Success
     * @throws ApiError
     */
    public static userReloadUser(
        sessionId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/User/Reload',
            query: {
                'sessionId': sessionId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns MyEstateDto Success
     * @throws ApiError
     */
    public static userGetMyEstate(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<MyEstateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/User/Estate',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @returns string Success
     * @throws ApiError
     */
    public static userGetContactId(
        sessionId?: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/User/GetContactId',
            query: {
                'sessionId': sessionId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns KycFormResponse Success
     * @throws ApiError
     */
    public static userGetMyKycForms(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<Array<KycFormResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/User/GetKycForms',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

}
